import React from 'react';
import { useDispatch } from 'react-redux';

import { modalMessages } from 'apps/web_forms/utils/constants';

import { resetModal } from 'apps/web_forms/slices/appSlice';
import Modal from 'apps/web_forms/components/commons/Modal';

export const ReassignDraftSuccessModal = ({resetSelectedModal}) => {

  return (
    <Modal
      mainMessage={modalMessages.draftReassignSuccess.main}
      helpTip={modalMessages.draftReassignSuccess.tip}
      isOpen={true}
      setIsOpen={resetSelectedModal}
      icon='success'
    />
  );
};